
export default {
  name: "SpinnerButton",
  props: {
    fsi: {
      type: String,
      default: '17'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: 'white',
    },
    width: {
      type: String,
      required: false,
      default: '225',
    },
    height: {
      type: String,
      required: false,
      default: '50'
    },
    redhover: {
      type: Boolean,
      required: false,
      default: false
    },
    dis: {
      type: Boolean,
      required: false,
      default: false
    },    
    disbuy: {
      type: Boolean,
      required: false,
      default: false
    },    
    whitehover: {
      type: Boolean,
      required: false,
      default: false
    }    
  },
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
